module.exports = __webpack_public_path__ + "static/oranges-fb498e82f4f408ee1e9225c53e3b68d8.jpg";